package com.yogaaicoach.pages.insights

import com.yogaaicoach.pages.insights.data.WeeklySummaryResponse
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDate
import kotlinx.datetime.number
import kotlinx.datetime.plus

internal data class WorkoutEntry(
    val weekday: String,
    val focusArea: String,
    val durationMin: Int,
)

internal data class WeekSummary(
    val weekLabel: String,
    val totalMinutes: Int,
    val sessions: Int,
    val workouts: List<WorkoutEntry>,
    val changePercent: Int?,
) {
    val avgSessionMin: Int get() = totalMinutes / sessions
    val sessionLabel: String get() = "$sessions ${if (sessions == 1) "session" else "sessions"}"
}

private val monthAbbr = listOf("Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec")

internal fun WeeklySummaryResponse.toWeekSummary(): WeekSummary {
    val start = LocalDate.parse(weekStart)
    val end = start.plus(6, DateTimeUnit.DAY)
    val label = if (start.month.number == end.month.number) {
        "${monthAbbr[start.month.number - 1]} ${start.day} – ${end.day}"
    } else {
        "${monthAbbr[start.month.number - 1]} ${start.day} – ${monthAbbr[end.month.number - 1]} ${end.day}"
    }
    return WeekSummary(
        weekLabel = label,
        totalMinutes = totalMinutes,
        sessions = sessions,
        changePercent = changePercent,
        workouts = workouts.map { WorkoutEntry(it.weekday, it.focusAreas.firstOrNull() ?: "", it.durationMin) },
    )
}
